import { checkIsInternalCompany } from 'app/auth/authUtils';
import { FORM_BUNDLES_ROUTING_PARAMS, FormsPaths } from 'app/configs/routesConfig/forms';
import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

export const selectFormBundles = ({ formBundles }) => formBundles;

export const selectFormBundleById = memoizeOne(formBundleId =>
  createSelector(selectFormBundles, formBundles => formBundles[formBundleId]),
);

const selectFormBundlesValues = createSelector(selectFormBundles, Object.values);

export const selectNonDraftFormBundlesValues = createSelector(selectFormBundlesValues, bundles =>
  bundles.filter(({ isDraft }) => !isDraft),
);

const selectExtendedFormBundles = createSelector(selectFormBundlesValues, formBundles =>
  formBundles.map(bundle => ({
    ...bundle,
    pathToBundle: FormsPaths.viewFormBundle.generatePath({
      [FORM_BUNDLES_ROUTING_PARAMS.formBundleId]: bundle.formBundleId,
    }),
  })),
);

export const selectFormBundlesExceptPassed = memoizeOne(bundleId =>
  createSelector(selectExtendedFormBundles, formBundles =>
    formBundles.filter(bundle => bundle.formBundleId !== bundleId),
  ),
);

export const selectFormBundlesWithFormsSortedByName = createSelector(
  selectExtendedFormBundles,
  formBundles =>
    _.orderBy(
      formBundles.map(({ forms, ...bundle }) => ({
        ...bundle,
        forms: _.orderBy(forms, [({ name }) => name.toLowerCase()]),
      })),
      [({ name }) => name.toLowerCase()],
    ),
);

export const selectFormBundlesOptions = createSelector(selectFormBundlesValues, values =>
  values.map(({ name, formBundleId }) => ({ name, value: formBundleId })),
);

// A Document Review task delivers a per-task copy of its bundle, and a global bundle cannot be copied.
export const selectDocumentReviewFormBundlesOptions = createSelector(
  selectNonDraftFormBundlesValues,
  values =>
    values
      .filter(({ companyId }) => !checkIsInternalCompany({ companyId }))
      .map(({ name, formBundleId }) => ({ name, value: formBundleId })),
);

export const selectExtendedFormBundlesOptions = createSelector(selectFormBundlesValues, values =>
  values.map(({ name, formBundleId, forms, documentTypeId }) => ({
    name,
    value: formBundleId,
    documentTypeId,
    forms: forms?.map(({ formElementId, name }) => ({ value: formElementId, name })) ?? [],
  })),
);
